export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/admin/profile/personal-info', 'admin.personal-info')
    .when('/admin/profile/security', 'admin.settings')

    .within('admin')

    .segment('personal-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.profile'
      }],
      template: '<admin-personal-info-page></admin-personal-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-personal-info.module" */ "./personal-info/admin-personal-info.module");
      }
    })

    .segment('settings', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.profile'
      }],
      template: '<admin-security-page></admin-security-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-security.module" */ "./security/admin-security.module");
      }
    });
}
